import React, { useEffect, useState } from "react";
import RTextField from "./RTextField";
import RTextArea from "./RTextArea";
import RSelectList from "./RSelectList";
import RCheckBox from "./RCheckBox";

const TEXT = "TEXT";
const TEXTAREA = "TEXTAREA";
const SELECTLIST = "SELECTLIST";
const CHECKBOX = "CHECKBOX";

export const getValue = (extConfigValues, key) => {
  const result = extConfigValues.find((v) => v.id === key);
  return result ? result.value : "";
};

const AtlassianFormBuilder = ({ fields = [], values = [], options = [], update }) => {
  //console.log("fields:" + fields, "val:" + values, "op:" + options);
  const [currentValues, setCurrentValues] = useState(values || []);

  useEffect(() => {
    setCurrentValues(values || []);
  }, [values]);

  const propagateValueChange = (dataValue) => {
    setCurrentValues((prevValues = []) => {
      const nextValues = prepareDataSet(prevValues, dataValue);
      if (typeof update === "function") {
        update(nextValues);
      }
      return nextValues;
    });
  };

  const onBlur = (data) => {
    const id = data.target.name;
    const val = data.target.value;
  };

  const onCheckBoxClicked = (event) => {
    const dataValue = { id: event.target.name, value: event.target.checked };
    propagateValueChange(dataValue);
  };
  const onTextChange = (data) => {
    const id = data.target.name;
    const val = data.target.value;
    const dataValue = { id: id, value: val };
    propagateValueChange(dataValue);
  };
  const onPick = (data, id) => {
    let dataValue;
    if (Array.isArray(data)) {
      dataValue = { id: id, value: data.map((item) => item.value) };
    } else {
      dataValue = { id: id, value: data.value };
    }
    propagateValueChange(dataValue);
  };

  //const uiFields = renderFields(fields, values, options, onTextChange, onBlur, onPick);

  const uiFields = renderFields(fields, currentValues, options, onTextChange, onBlur, onPick, onCheckBoxClicked);

  return <div style={{ position: "relative", zIndex: "100" }}>{uiFields}</div>;
};
const renderFields = (fields, values, options, onTextChange, onBlur, onPick, onCheckBoxClicked) => {
  return fields.map((f) => {
    switch (f.type) {
      case TEXT:
        return (
          <RTextField
            key={f.id}
            title={f.title}
            value={getValueFromState(values, f.id)}
            defaultValue={f.defaultValue ? f.defaultValue : ""}
            id={f.id}
            helperText={f.helperText ? f.helperText : ""}
            width={f.width}
            isDisabled={f.isDisabled}
            onBlur={onBlur}
            onChange={onTextChange}
            isPassword={f.isPassword}
          />
        );
        break;
      case TEXTAREA:
        return (
          <RTextArea
            key={f.id}
            title={f.title}
            value={getValueFromState(values, f.id)}
            defaultValue={f.defaultValue ? f.defaultValue : ""}
            id={f.id}
            helperText={f.helperText ? f.helperText : ""}
            width={f.width}
            minimumRows={f.minimumRows}
            isDisabled={f.isDisabled}
            onBlur={onBlur}
            onChange={onTextChange}
          />
        );
        break;
      case SELECTLIST:
        return (
          <RSelectList
            key={f.id}
            title={f.title}
            value={getSelectedValueFromState(values, options, f.id)}
            defaultValue={f.defaultValue ? f.defaultValue : ""}
            id={f.id}
            options={getOptionsForField(options, f.id)}
            helperText={f.helperText ? f.helperText : ""}
            width={f.width}
            isDisabled={f.isDisabled}
            isMulti={f.isMulti ? f.isMulti : false}
            onChange={(item) => onPick(item, f.id)}
          />
        );
        break;
      case CHECKBOX:
        return (
          <RCheckBox
            key={f.id}
            title={f.title}
            value={f.id}
            checkboxValueLabel={f.checkboxValueLabel}
            isChecked={getBooleanValueFromState(values, f.id)}
            id={f.id}
            helperText={f.helperText ? f.helperText : ""}
            width={f.width}
            isDisabled={f.isDisabled}
            onBlur={onBlur}
            onChange={onCheckBoxClicked}
            size="large"
          />
        );
        break;

      default:
        break;
    }
  });
};

const prepareDataSet = (currentValues, dataValue) => {
  if (!currentValues || currentValues.length === 0) return [dataValue];
  let result = currentValues.filter((item) => item.id !== dataValue.id);
  result.push(dataValue);
  return result;
};

const getValueOfId = (values, id) => {
  if (!values) return [];
  return values.find((item) => item.id === id);
};
const getValueFromState = (values, id) => {
  if (!values) return "";
  const val = getValueOfId(values, id);
  return val ? val.value : "";
};

const getBooleanValueFromState = (values, id) => {
  if (!values) return false;
  const val = getValueOfId(values, id);
  return val ? val.value : false;
};

const getSelectedValueFromState = (values, options, id) => {
  if (!values) return [];
  const fieldValue = getValueOfId(values, id);
  if (!fieldValue) return [];
  //find which list of options to use
  const fieldOptions = options.find((optState) => optState.id === id);
  if (fieldOptions && fieldOptions.length == 0) return [];

  let selectedValue;
  //is multiselect?
  if (Array.isArray(fieldValue.value)) {
    selectedValue = fieldValue.value.map((fv) => getOptionForFieldValue(fv, fieldOptions));
  } else {
    selectedValue = getOptionForFieldValue(fieldValue.value, fieldOptions);
  }
  return selectedValue;
};
const getOptionForFieldValue = (fValue, fieldOptions) => {
  if (!fieldOptions && !fieldOptions.values) return "";
  return fieldOptions.values.find((opt) => opt.value === fValue);
};
const getOptionsForField = (options, field) => {
  if (!options) return [];
  const list = options.find((opt) => opt.id === field);
  return list ? list.values : [];
};
export default AtlassianFormBuilder;
